import { useSyncExternalStore } from "react";
import type { FeedbackContext } from "./support-client";

/** A screen's ask for a bug report: what it knew when it went wrong, for the ticket's header. */
export interface BugReportRequest {
  context: FeedbackContext;
}

let current: BugReportRequest | null = null;
const listeners = new Set<() => void>();

function emit(next: BugReportRequest | null): void {
  current = next;
  for (const listener of listeners) listener();
}

/**
 * Open the feedback form on a bug report carrying `context`. A module store,
 * so a screen anywhere asks without a provider above both it and the header.
 * Each ask is a new object, so asking again opens the form again.
 */
export function requestBugReport(
  context: Readonly<Record<string, string>>,
): void {
  emit({ context });
}

/** The form that took the request has closed, so its ids are not held for the rest of the visit. */
export function dismissBugReportRequest(): void {
  emit(null);
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

const snapshot = () => current;

export function useBugReportRequest(): BugReportRequest | null {
  return useSyncExternalStore(subscribe, snapshot);
}
